<template>
  <div class="coupon_main">
    <div v-for="(item, index) in yhjeList" :key="index">
      <p>{{ item.name }}</p>
      <div>
        <span class="font14 money-color">¥{{ item.price }}</span>
        <span class="font12 grey">&nbsp;x{{ item.amount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    yhjeList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.coupon_main {
  padding: 10px 16px;
  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .grey {
      color: #969799;
    }
  }
}
</style>
